/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
const USLayout = {
    normal: [
        [
            { value: "1", type: "standard" },
            { value: "2", type: "standard" },
            { value: "3", type: "standard" },
            { value: "4", type: "standard" },
            { value: "5", type: "standard" },
            { value: "6", type: "standard" },
            { value: "7", type: "standard" },
            { value: "8", type: "standard" },
            { value: "9", type: "standard" },
            { value: "0", type: "standard" },
            { value: "<-", type: "standard" }
        ],
        [
            { value: "q", type: "standard" },
            { value: "w", type: "standard" },
            { value: "e", type: "standard" },
            { value: "r", type: "standard" },
            { value: "t", type: "standard" },
            { value: "y", type: "standard" },
            { value: "u", type: "standard" },
            { value: "i", type: "standard" },
            { value: "o", type: "standard" },
            { value: "p", type: "standard" },
            { value: "Ent", type: "2vertical" }
        ],
        [
            { value: "a", type: "standard" },
            { value: "s", type: "standard" },
            { value: "d", type: "standard" },
            { value: "f", type: "standard" },
            { value: "g", type: "standard" },
            { value: "h", type: "standard" },
            { value: "j", type: "standard" },
            { value: "k", type: "standard" },
            { value: "l", type: "standard" },
            { value: '"', type: "standard" }
        ],
        [
            { value: "Shift", type: "2horizontal" },
            { value: "z", type: "standard" },
            { value: "x", type: "standard" },
            { value: "c", type: "standard" },
            { value: "v", type: "standard" },
            { value: "b", type: "standard" },
            { value: "n", type: "standard" },
            { value: "m", type: "standard" },
            { value: "Alt", type: "2horizontal" }
        ],
        [
            { value: "Close", type: "2horizontal" },
            { value: "", type: "5horizontal" },
            { value: ",", type: "standard" },
            { value: ".", type: "standard" },
            { value: "Save", type: "2horizontal" }
        ]
    ],
    shift: [
        [
            { value: "1", type: "standard" },
            { value: "2", type: "standard" },
            { value: "3", type: "standard" },
            { value: "4", type: "standard" },
            { value: "5", type: "standard" },
            { value: "6", type: "standard" },
            { value: "7", type: "standard" },
            { value: "8", type: "standard" },
            { value: "9", type: "standard" },
            { value: "0", type: "standard" },
            { value: "<-", type: "standard" }
        ],
        [
            { value: "Q", type: "standard" },
            { value: "W", type: "standard" },
            { value: "E", type: "standard" },
            { value: "R", type: "standard" },
            { value: "T", type: "standard" },
            { value: "Y", type: "standard" },
            { value: "U", type: "standard" },
            { value: "I", type: "standard" },
            { value: "O", type: "standard" },
            { value: "P", type: "standard" },
            { value: "Ent", type: "2vertical" }
        ],
        [
            { value: "A", type: "standard" },
            { value: "S", type: "standard" },
            { value: "D", type: "standard" },
            { value: "F", type: "standard" },
            { value: "G", type: "standard" },
            { value: "H", type: "standard" },
            { value: "J", type: "standard" },
            { value: "K", type: "standard" },
            { value: "L", type: "standard" },
            { value: '"', type: "standard" }
        ],
        [
            { value: "Shift", type: "2horizontal" },
            { value: "Z", type: "standard" },
            { value: "X", type: "standard" },
            { value: "C", type: "standard" },
            { value: "V", type: "standard" },
            { value: "B", type: "standard" },
            { value: "N", type: "standard" },
            { value: "M", type: "standard" },
            { value: "Alt", type: "2horizontal" }
        ],
        [
            { value: "Close", type: "2horizontal" },
            { value: "", type: "5horizontal" },
            { value: ",", type: "standard" },
            { value: ".", type: "standard" },
            { value: "Save", type: "2horizontal" }
        ]
    ],
    alt: [
        [
            { value: "1", type: "standard" },
            { value: "2", type: "standard" },
            { value: "3", type: "standard" },
            { value: "4", type: "standard" },
            { value: "5", type: "standard" },
            { value: "6", type: "standard" },
            { value: "7", type: "standard" },
            { value: "8", type: "standard" },
            { value: "9", type: "standard" },
            { value: "0", type: "standard" },
            { value: "<-", type: "standard" }
        ],
        [
            { value: "~", type: "standard" },
            { value: "`", type: "standard" },
            { value: "|", type: "standard" },
            { value: "(", type: "standard" },
            { value: ")", type: "standard" },
            { value: "^", type: "standard" },
            { value: "_", type: "standard" },
            { value: "-", type: "standard" },
            { value: "=", type: "standard" },
            { value: "!", type: "standard" },
            { value: "Ent", type: "2vertical" }
        ],
        [
            { value: "@", type: "standard" },
            { value: "#", type: "standard" },
            { value: "$", type: "standard" },
            { value: "%", type: "standard" },
            { value: "*", type: "standard" },
            { value: "[", type: "standard" },
            { value: "]", type: "standard" },
            { value: "#", type: "standard" },
            { value: "<", type: "standard" },
            { value: "?", type: "standard" }
        ],
        [
            { value: "Shift", type: "2horizontal" },
            { value: ":", type: "standard" },
            { value: ";", type: "standard" },
            { value: "{", type: "standard" },
            { value: "}", type: "standard" },
            { value: "/", type: "standard" },
            { value: "\\", type: "standard" },
            { value: ">", type: "standard" },
            { value: "Alt", type: "2horizontal" }
        ],
        [
            { value: "Close", type: "2horizontal" },
            { value: "", type: "5horizontal" },
            { value: ",", type: "standard" },
            { value: ".", type: "standard" },
            { value: "Save", type: "2horizontal" }
        ]
    ]
};

export default USLayout;
